import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classnames from 'classnames';
import { TextLink } from '@sbt-web/ui';
import type { InternalLink } from './types';
import classes from './Sidebar.module.scss';
interface Props {
  links: InternalLink[];
}
interface GroupProps {
  title: string;
  links: InternalLink[];
}
const Group: FC<GroupProps> = t0 => {
  const $ = _c(3);
  const {
    title,
    links
  } = t0;
  let t1;
  if ($[0] !== links || $[1] !== title) {
    t1 = links.length <= 0 ? null : <div className={classes.group}><h6 className={classnames("headline-6", classes["group-title"])}>{title}</h6><ul className={classes["group-links"]}>{links.map(_temp)}</ul></div>;
    $[0] = links;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const Sidebar: FC<Props> = t0 => {
  const $ = _c(22);
  const {
    links
  } = t0;
  if (links.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== links) {
    t1 = links.slice(0, 7);
    $[0] = links;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const correlatedLinks = t1;
  let t2;
  if ($[2] !== links) {
    t2 = links.slice(7, 14);
    $[2] = links;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const similarSearchesLinks = t2;
  let t3;
  if ($[4] !== links) {
    t3 = links.slice(14, 21);
    $[4] = links;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const suggestionsLinks = t3;
  let t4;
  if ($[6] !== links) {
    t4 = links.slice(21, 28);
    $[6] = links;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const alsoDiscoverLinks = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h5 className="headline-5">Più cercati</h5>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== correlatedLinks) {
    t6 = <Group title="Correlati" links={correlatedLinks} />;
    $[9] = correlatedLinks;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== similarSearchesLinks) {
    t7 = <Group title="Richerche simili" links={similarSearchesLinks} />;
    $[11] = similarSearchesLinks;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== suggestionsLinks) {
    t8 = <Group title="Suggerimenti" links={suggestionsLinks} />;
    $[13] = suggestionsLinks;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== alsoDiscoverLinks) {
    t9 = <Group title="Scopri anche" links={alsoDiscoverLinks} />;
    $[15] = alsoDiscoverLinks;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <aside className={classes.container}>{t5}{t6}{t7}{t8}{t9}</aside>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
export default Sidebar;
function _temp(link) {
  return <li key={link.href}><TextLink href={link.href} size="sm" weight="book" classes={[classes.link]} themed={false}>{link.label}</TextLink></li>;
}